import React from 'react';

import { useTranslation } from 'react-i18next';

import StatusIndicator from 'components/application/indicators/StatusIndicator';
import Tooltip from 'components/application/Tooltip';

export default function TrainingStatus({
  currentTrainingStatus,
  isRequired,
  requiredSource,
}) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'training.TrainingStatus',
  });

  const { t: i18nTCommon } = useTranslation('common');

  const trainingStatusOptions = {
    valid: {
      status: 'low',
      tooltipText:
        isRequired ?
          i18nTCommon('training.trainingIsUpToDate')
        : i18nT('tooltip.valid'),
    },
    expiryDateMissing: {
      status: isRequired ? 'high' : 'grey',
      tooltipText:
        isRequired ?
          i18nTCommon('shared.expiryDateIsMissing')
        : i18nT('tooltip.expiryDateMissing'),
    },
    expiring: {
      status: isRequired ? 'medium' : 'low',
      tooltipText:
        isRequired ?
          requiredSource === 'UserCourse' ?
            i18nT('tooltip.expiring.requiredByUserCourse')
          : i18nTCommon('training.trainingIsExpiringSoon')
        : i18nT('tooltip.expiring.notRequired'),
    },
    expired: {
      status: isRequired ? 'high' : 'grey',
      tooltipText: i18nT(
        `tooltip.expired.${
          isRequired ?
            requiredSource === 'UserCourse' ?
              'requiredByUserCourse'
            : 'required'
          : 'notRequired'
        }`,
      ),
    },
    invalid: {
      status: isRequired ? 'high' : 'grey',
      tooltipText: i18nTCommon('shared.expiryDateNotSet'),
    },
    missing: {
      status: isRequired ? 'high' : 'grey',
      tooltipText:
        isRequired ?
          requiredSource === 'UserCourse' ?
            i18nT('tooltip.missing.requiredByUserCourse')
          : i18nTCommon('training.trainingIsMissing')
        : i18nT('tooltip.missing.notRequired'),
    },
    archived: {
      status: 'hollow',
      tooltipText: i18nTCommon('personnel.archived'),
    },
  };

  return (
    <div className='tooltip-parent tw-flex'>
      <StatusIndicator
        status={trainingStatusOptions[currentTrainingStatus].status}
      />
      <Tooltip
        placement='top'
        tooltip={trainingStatusOptions[currentTrainingStatus].tooltipText}
        trigger='hover'
      />
    </div>
  );
}
